<template>
  <div :id="$route.path === '/bind' ? '' : 'app'">
    <header v-if="$route.path != '/bind'">
      <Header
        @animationstart.native="onAnimationStart"
        :class="{ [animationName]: $route.name === 'home' }"
        :fixedToTop="$route.path === '/'"
        ref="header"
        :theme-color="themeColor"
      ></Header>
    </header>
    <main>
      <transition appear :name="pageTransitionName">
        <router-view :key="$route.path"></router-view>
      </transition>
    </main>
    <footer v-if="$route.name !== 'products'">
      <Footer></Footer>
    </footer>

    <!-- 弹窗代码开始 -->
    <div v-if="false" class="web_notice" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,0.3);z-index: 99999;">
      <div :class="this.isMobile.value ? 'notice-dialog-mobile' : 'notice-dialog'">
        <h3 style="font-weight: bold;text-align: center;font-size: 30px;
">关于赣州产控集团限额以上甲供材项目电子招投标的公告</h3><div style="font-size: 16px;margin-top: 26px;line-height: 30px;color: #999;
">赣州产控集团限额以上甲供材项目将在江西省公共资源交易网(https://www. jxsgzy.cn/web/)采用电子招投标，请有意向参与赣州产控集团及其下属子公司甲供材项目招标的投标人，提前办理好CA锁并熟悉电子招投标的操作流程。CA锁的办理及电子投标具体操作请各潜在投标人在江西省公共资源交易网-服务指南-投标单位，自行下载“关于办理江西省公共资源网上交易系统江西CA移动数字证书（赣标通）的说明”和“江西省房建及市政通用模版范本操作手册”，也可在赣州招投标培训网(http://jxgz.ebpu.com/sysConfigItem/showList)中下载观看“不见面开标操作培训”。有任何疑议，可致电新点赖工：18179120533。</div><a style="display: block;background: #162AD4FF;color: #FFF;text-align: center;font-weight: bold;font-size: 19px;line-height: 60px;margin: 0 auto;margin-top: 45px;border-radius: 32px;width: 80%;" @click="iKnow">我知道了</a></div></div>
    <!-- 弹窗代码结束 -->
  </div>
</template>
<script>
import isMobile from "@/api/isMobile";

export default {
  name: "App",
  components:{
    // Header
  },
  data() {
    return {
      homeScrollY: 0,
      pageTransitionName: "",
      animationName: "",
      isDisplay: true
    };
  },

  computed: {
    themeColor() {
      return this.$route.path !== "/"
        ? "main-color"
        : this.homeScrollY < Math.max(400, window.innerHeight)
        ? "is-transparent"
        : "main-color";
    }
  },
  created() {
    this.$root.$on("home-scrolling", (direction, pos) => {
      this.homeScrollY = pos.y;

      // if (direction.directionY === -1) {
      //   this.animationName = "slideInDown";
      // } else {
      //   this.animationName = "slideOutUp";
      // }
    });
    isMobile.value = this._isMobile();
  },
  mounted() {
    // this.$refs.header.$el.addEventListener("animationend", function(e) {
    //   if (e.animationName === "slideOutUp") {
    //     e.target.style.top = "-100%";
    //   }
    // });
  },
  watch: {
    $route(newRoute) {
      this.pageTransitionName = ["products", "home"].includes(newRoute.name)
        ? ""
        : "jumpPage";
      this.isDisplay = true;
    }
  },
  methods: {
    iKnow(){
      this.isDisplay = false;
    },
    onAnimationStart(e) {
      if (e.animationName === "slideInDown") {
        e.target.style.top = 0;
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
};
</script>
<style lang="less">
  html{
    height: 100%;
  }
  body{
    height: 100%;
  }
@keyframes slideInDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slideOutUp {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-100%);
  }
}
.slideInDown {
  animation: slideInDown 0.4s;
}
.slideOutUp {
  animation: slideOutUp 0.4s;
}

.jumpPage-leave-active {
  display: none;
}
.jumpPage-enter {
  transform: translate3d(0, 80px, 0);
  opacity: 0;
}

.jumpPage-enter-active {
  transition: all 0.3s;
}
#app {
  //min-width: 1200px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
footer {
  /*margin-top: 100px;*/
}

header {
  position: relative;
  z-index: 1000;
}
a{
  text-decoration:none;
  color: black;
}
  main{
    flex: 1;
  }
  .detail-line .detail-value{
    word-break: break-word;
  }
  .notice-dialog{
    position: fixed;
    top: 50%;left: 50%;
    width: 550px;
    background: #FFF;
    transform: translate(-50%, -50%);
    border-radius: 40px;
    padding: 50px 40px;
  }
  .notice-dialog-mobile{
    position: fixed;
    top: 50%;left: 50%;
    width: 420px;
    background: #FFF;
    transform: translate(-50%, -50%);
    border-radius: 40px;
    padding: 50px 40px;
  }
</style>
